import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const CustomCircularProgress = ({ size }) => {
  return <CircularProgress size={size} thickness={6} />;
};

export default CustomCircularProgress;
